<template>
  <div class="test">
    <div class="more-table-in">
      <div class="">
        <div class="test-search-index">
          Search Index
          <span class="test-search-desc">you can get aaaid by this. </span>
        </div>
        <div class="test-flex-box">
          <el-select
            v-model="companyCountry"
            clearable
            filterable
            value-key="id"
            placeholder="companyCountry"
            style="width: 100%"
          >
            <el-option
              v-for="country in dataRangeList.countryType"
              :key="'countryType' + country.code"
              :label="country.descEn"
              :value="country.code"
            >
            </el-option>
          </el-select>
          <el-input v-model="companyName" placeholder="companyName"> </el-input>
          <el-input v-model="regNumber" placeholder="regNumber"> </el-input>
          <div>
            <el-button type="primary" @click="toSearchIndex()"
              >Search</el-button
            >
          </div>
        </div>
      </div>
      <div class="test-flex-box" v-if="searchIndexResult">
        <div class="test-flex-1">
          <div class="test-from-title">Result</div>
          <div>
            <el-input
              type="textarea"
              v-model="searchIndexResult"
              :autosize="{ minRows: 5, maxRows: 15 }"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="test-flex-box">
        <div class="test-flex-1">
          <div class="test-from-title">Select Interface</div>
          <div>
            <el-select
              v-model="apiId"
              clearable
              placeholder="Select"
              style="width: 100%"
              @change="apiChange"
            >
              <el-option
                v-for="item in apiOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="test-flex-1">
          <div class="test-from-title">Select Test Account</div>
          <div>
            <el-select
              v-model="appKey"
              clearable
              placeholder="Select"
              style="width: 100%"
              @change="appKeyChange"
            >
              <el-option
                v-for="item in appKeysOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="test-flex-box">
        <div class="test-flex-1">
          <div class="test-from-title">RequestParams</div>
          <div>
            <el-input type="textarea" v-model="requestParams" rows="5">
            </el-input>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <el-button type="primary" @click="toInitiateTestCall()"
          >Initiate test call</el-button
        >
      </div>
      <div v-if="isTestContent">
        <div class="info-list-title">Test call result</div>
        <div class="info-list-desc-content">
          <div class="copyimgbtn" @click="copybtn()">
            <img
              src="../../../assets/images/dataServices/dataapi-img/copytestbtn.svg"
              alt=""
            />
          </div>
          <div>
            <pre>{{ formattedJson(testCallResult) }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDataRange,
  getFilterList,
  getApiDataApiItemById,
  apiDataCall,
} from "@/api/dataServicesApi";
import { searchCompany } from "@/api/searchApi";
export default {
  props: [],
  data() {
    return {
      // companyCountry: "US",
      // companyName:'APPLE INC',
      // regNumber:'806592',
      companyCountry: "",
      companyName: "",
      regNumber: "",
      searchIndexResult: "",
      dataRangeList: {},
      apiName: "",
      apiId: "",
      appKey: "",
      requestParams: "", //返回的入参示列 get取requestParams post取requestBody
      apiOptions: [],
      appKeysOptions: [],
      testCallResult: {},
      isTestContent: false,
    };
  },
  components: {},
  computed: {},
  watch: {},
  created() {
    this.getFilterList(); //第一次调接口 取用所有api的下拉数据
    if (this.$route.query.apiName) {
      this.apiName = this.$route.query.apiName;
      this.apiId = this.getapiName(this.apiName, 2);
    }
    console.log("this.apiId", this.apiId);
    if (this.$route.query.appKey) {
      this.appKey = this.$route.query.appKey;
    }
    this.getDataRangeFn();
  },
  mounted() {},
  methods: {
    // 获取国家下拉框
    async getDataRangeFn() {
      let arrData = localStorage.getItem("bulkDataServiceRange");
      if (arrData) {
        this.dataRangeList = JSON.parse(
          localStorage.getItem("bulkDataServiceRange")
        );
        return;
      }
      await getDataRange().then((res) => {
        if (res.code == 200 && res.data) {
          this.dataRangeList = res.data;
          localStorage.setItem(
            "bulkDataServiceRange",
            JSON.stringify(res.data)
          );
        }
      });
    },
    // 搜索索引
    async toSearchIndex() {
      let params = {
        company_country: this.companyCountry,
        company_name: this.companyName,
        reg_number: this.regNumber,
      };
      let res = await searchCompany(params);
      if (res.data) {
        let resultArr = res.data.rows.map((item) => ({
          aaa_id: item.aaa_id,
          company_name: item.company_name,
          reg_number: item.reg_number,
          company_type_en: item.company_type_en,
          status_en: item.status_en,
          isic_code: item.isic_code,
          isic_en: item.isic_en,
          qcscore: item.qcscore,
          isic_en: item.isic_en,
          province: item.province,
        }));
        this.searchIndexResult = this.formattedJson(JSON.stringify(resultArr));
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取下拉数据
    getFilterList() {
      let params = {
        appKey: this.appKey,
        apiName: this.apiName,
        apiId: this.apiId,
      };
      getFilterList(params).then((res) => {
        if (res.code == 200) {
          let apiList = JSON.parse(JSON.stringify(res.data.apiInfos));
          console.log("apiList", apiList);
          //  将数据转成[{label:'',value:''}]格式 并且按照字母大小排序（后端返回对象是按照字母大小排序的 但对象其实是无序的所以前端需要手动排序）
          this.apiOptions = Object.entries(apiList)
            .map(([label, value]) => ({ label, value }))
            .sort((a, b) => a.label.localeCompare(b.label));
          console.log("this.apiOptions", this.apiOptions);
          if (this.$route.query) {
            this.apiName = this.$route.query.apiName
              ? this.$route.query.apiName
              : "";
            this.apiId = this.apiName ? this.getapiName(this.apiName, 2) : "";
            this.appKey = this.$route.query.appKey
              ? this.$route.query.appKey
              : "";
            this.appKeysOptions = [this.appKey].map((key) => ({
              label: key,
              value: key,
            }));
            this.appKeyChange(this.appKey);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 区分开 联动的接口
    getFilterList_2() {
      let params = {
        appKey: this.appKey,
        apiName: this.apiName,
        apiId: this.apiId,
      };
      getFilterList(params).then((res) => {
        if (res.code == 200) {
          let appKeysList = JSON.parse(JSON.stringify(res.data.appKeys));
          this.appKeysOptions = appKeysList.map((key) => ({
            label: key,
            value: key,
          }));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getapiName(newVal, type) {
      if (type == 1) {
        // 根据value找到对应的label
        let item = this.apiOptions.find((opt) => opt.value === newVal);
        return item ? item.label : "";
      } else {
        // 根据label找到对应的value
        let item = this.apiOptions.find((opt) => opt.label === newVal);
        return item ? item.value : "";
      }
    },
    apiChange(val) {
      // 切换api时再次调用接口 获取appkey的下拉数据
      this.appKey = ""; //置空原来选项
      this.requestParams = "";
      this.apiName = this.getapiName(val, 1);
      console.log("this.apiName2", this.apiName);
      this.getFilterList_2();
    },
    appKeyChange(val) {
      // 确认好下拉数据后调用"获取接口详情明细接口 获取入参示列
      if (!val) return;
      this.getApiDataApiItemByIdList();
    },
    // 获取详情数据
    async getApiDataApiItemByIdList() {
      let res = await getApiDataApiItemById(`?id=${this.apiId}`);
      console.log("res---", res, res.code);
      if (res.code == 200) {
        let apiInfo = JSON.parse(JSON.stringify(res.data));
        // 入参示列
        this.requestParams = this.formattedJson(apiInfo.requestBody);
        // if (apiInfo.requestMethod == "GET") {
        //   this.requestParams = this.formattedJson(apiInfo.requestParams);
        // } else if (apiInfo.requestMethod == "POST") {
        //   this.requestParams = this.formattedJson(apiInfo.requestBody);
        // }
        // console.log("responseBody", this.formattedJson(apiInfo.responseBody));
        // console.log("apiInfo", apiInfo, this.requestParams);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 展示json对象
    formattedJson(data) {
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        return "Invalid JSON";
      }
    },
    toInitiateTestCall() {
      let params = {
        appKey: this.appKey,
        apiId: this.apiId,
        requestItems: JSON.stringify(JSON.parse(this.requestParams)),
      };
      apiDataCall(params).then((res) => {
        if (res.data) {
          this.testCallResult = JSON.stringify(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
      this.isTestContent = true;
    },
    copybtn() {
      this.copyTool(this.requestParams);
    },
    async copyTool(data) {
      try {
        await this.$copyText(data);
        this.$message({
          message: "Copied",
          type: "success",
        });
      } catch (err) {
        this.$message({
          message: "Failed to copy: " + err,
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.test {
  background-color: #fff;
  border-radius: 10px;
  /* margin-bottom: 50px; */
}

.more-table-in {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 30px 40px;
  min-height: calc(100vh - 193px);
}
.test-flex-box {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  margin-bottom: 40px;
}
.test-search-index {
  color: #1a2332;
  font-size: 16px;
  margin-bottom: 13px;
  font-weight: bold;
}
.test-search-desc {
  color: #1a2332;
  font-size: 14px;
}
.test-flex-1 {
  flex: 1;
}
.test-from-title {
  color: #1a2332;
  font-size: 16px;
  margin-bottom: 13px;
  font-weight: bold;
}
/* 标准写法（现代浏览器） */
.test /deep/ input::placeholder {
  color: #999999;
  opacity: 1; /* 某些浏览器默认 opacity < 1 */
  font-size: 14px;
}
.info-list-title {
  font-size: 20px;
  color: #1a2332;
}
.btn-box {
  margin-bottom: 20px;
}
.info-list-desc-content {
  margin-top: 20px;
  background-color: #f5f5f5;
  padding: 40px;
  border: 1px solid #dddddd;
  color: #1a2332;
  font-size: 20px;
}
.copyimgbtn {
  text-align: right;
}
.copyimgbtn img {
  cursor: pointer;
  width: 26px;
  height: 26px;
}
pre {
  white-space: pre-wrap; /* 保留空格和换行，但允许自动换行 */
  word-wrap: break-word; /* 兼容旧浏览器 */
  word-break: break-word; /* 现代浏览器 */
  overflow-wrap: break-word; /* 标准属性 */
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  .test-search-index,.test-from-title{
    font-size:20px;
  }
  /* 字体 内容改成16px 包括按钮里字体*/
  .test-search-desc,.test-flex-box /deep/ .el-textarea__inner{
    font-size:16px;
  }
  /* 圆角 改成10px */
  .more-table-in{
    border-radius:10px;
  }
  /* padding *0.75 */
  .more-table-in{
    padding:23px 30px;
  }
  /* margin *0.75 */
   /* 表格 表头高度 44px 内容高度50px */
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  .test-search-index,.test-from-title{
    font-size:18px;
  }
  /* 字体 内容改成14px 包括按钮里字体*/
  .test-search-desc,.dataServices-theme .el-select-dropdown__item,.test-flex-box /deep/ .el-textarea__inner,.test-flex-box /deep/ .el-input{
    font-size:14px!important;
  }
  /* 圆角 改成8px */
  .more-table-in{
    border-radius:8px;
  }
  /* padding *0.67 */
  .more-table-in{
    padding:20px 27px;
  }
  /* margin *0.67 */
  /* 表格 表头高度 40px 内容高度44px*/
}
@media (max-width: 1279px) {
  .more-table-in {
    min-height: calc(100vh - 138px);
  }
}
</style>
